// Button Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import IntlMessage from '../../../common/common/intl/intl_message.jsx'

class Button extends Component {
  static get propTypes () {
    return {
      type: PropTypes.oneOf([
        'normal',
        'primary',
        'secondary',
        'status',
        'default',
        'success',
        'error',
        'cancel'
      ]),
      rounded: PropTypes.bool,
      invert: PropTypes.bool,
      select: PropTypes.bool,
      inActive: PropTypes.bool,
      className: PropTypes.string,
      size: PropTypes.oneOf(['small', 'big']),
      onClick: PropTypes.func,
      title: PropTypes.string,
      active: PropTypes.bool,
      hasBorder: PropTypes.bool
    }
  }

  static get defaultProps () {
    return {
      type: 'normal',
      rounded: false,
      invert: false,
      select: false,
      inActive: false,
      className: '',
      size: 'small',
      onClick: null,
      title: '',
      active: false,
      hasBorder: false
    }
  }

  render () {
    const {
      title,
      type,
      rounded,
      invert,
      select,
      inActive,
      className,
      size,
      onClick,
      hasBorder
    } = this.props
    const _class = classnames(
      'cbutton',
      `cbutton_${type}`,
      `cbutton_${size}`,
      className,
      {
        rounded,
        invert,
        select,
        inActive,
        hasborder: hasBorder
      }
    )

    return (
      <div className={_class} onClick={onClick}>
        <IntlMessage ident={title} />
      </div>
    )
  }
}

export default Button
